import type { Resource } from '@/features/resource/types'

type VisibilityParams = {
  resource: Resource | null | undefined
  /** Whether the viewer holds the `targetSocMutation` permission (ADMINISTRATORS-only). */
  hasTargetSocPermission: boolean
}

/**
 * The "SoC management" tab is shown only for LOCAL-control battery resources to ADMINISTRATORS
 * (the `targetSocMutation` permission). The route-mount gate in `ResourcesRoutes` checks the
 * permission alone (no resource in scope there); this predicate adds the per-resource LOCAL +
 * battery-control-port checks for the tab strip and the page itself.
 */
export function isSoCManagementTabVisible({ resource, hasTargetSocPermission }: VisibilityParams): boolean {
  if (!hasTargetSocPermission) return false
  if (!resource) return false
  if (resource.controlMode !== 'LOCAL') return false
  return resource.controlPorts.some((port) => port.controlBoxType === 'BATTERY')
}
